<div class="container-fluid">
  <div class="header-row">
    <div class="header-left">
      <div class="header-title"><span>{{ tab_name }}</span></div>
    </div>
  </div>

  <div class="chart-card">
    <div class="card-header-row">
      <h3 class="chart-title">Technology Summary</h3>

      <div class="metric-chips">
        <button *ngFor="let f of filters"
          type="button"
          class="metric-chip"
          [class.active]="activeFilter === f"
          (click)="applyFilter(f)">
          <span class="chip-dot" *ngIf="f !== 'All Fields'" [style.background]="getStageColor(f)"></span>
          {{ f }}
        </button>
      </div>
    </div>

    <div *ngIf="showSpinner" class="text-center py-4">
      <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div *ngIf="loadingFailed && !showSpinner" class="empty-state">
      <div class="empty-state-icon"><i class="bi bi-exclamation-circle"></i></div>
      <h5>No data available</h5>
      <p>Technology summary data could not be loaded.</p>
    </div>

    <div *ngIf="showTable && !showSpinner && !loadingFailed">
      <div *ngIf="filteredRows.length === 0" class="empty-state">
        <div class="empty-state-icon"><i class="bi bi-search"></i></div>
        <h5>No technologies in this stage</h5>
        <p>Try selecting a different stage above.</p>
      </div>

      <table class="table" *ngIf="filteredRows.length > 0">
        <thead>
          <tr>
            <th style="width:40%">Base Cluster</th>
            <th style="width:25%">Exposure</th>
            <th style="width:25%">S-Curve Stage</th>
            <th style="width:10%">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedRows">
            <td class="cell-cluster">{{ row.cluster_name }}</td>
            <td>{{ row.exposure | number:'1.1-1' }}%</td>
            <td>
              <span class="stage-badge"
                [style.background-color]="getStageBgColor(row.stage_name)"
                [style.color]="getStageColor(row.stage_name)">
                {{ row.stage_name }}
              </span>
            </td>
            <td>
              <button class="action-btn"
                (click)="submitTheme(row)"
                matTooltip="Open cluster in new tab">
                <i class="bi bi-box-arrow-up-right"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="paginator" *ngIf="totalPages > 1">
        <button class="page-btn" [disabled]="currentPage === 0" (click)="goToPage(currentPage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <button *ngFor="let p of pageNumbers"
          class="page-btn"
          [class.active]="p === currentPage"
          (click)="goToPage(p)">
          {{ p + 1 }}
        </button>
        <button class="page-btn" [disabled]="currentPage === totalPages - 1" (click)="goToPage(currentPage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
        <span class="page-info">{{ filteredRows.length }} technologies</span>
      </div>
    </div>
  </div>
</div>
